/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-common.utils',
    'pip-cart'
 ],
function(
    $,
    mustache,
    pip,
    utils,
    pipCart
){
    var view = {
        templates: {
            orderSample : $('#order-sample').html()
        },
        selectors: {
          orderSample: '.order-sample',
          orderSampleATC: '#order-sample__atc'
        },
        updateDOM: {
            updateSamplePrice: function(data){
              if (data.specialPrice) {
                data.orderSampleId = pip.products.primary.data.info.sampleId;
                $(view.selectors.orderSample).html(view.render.orderSampleLayout(data));
              } else {
                $(view.selectors.orderSample).hide();
              }
            }
        },
        render: {
            orderSampleLayout: function (data) {
                return mustache.render(view.templates.orderSample, data)
            }
        },
        initEventListeners: function(){
          $(window.document).off('.sampleATC');
          $(window.document).on('click.sampleATC', view.selectors.orderSampleATC, function() {
            pipCart.addSthItem(pip.products.primary.data.info.sampleId, 1);
          });
        }
    };
    var model = {
        fetch: {
            samplePriceData: function fetchSamplePriceData(){
                var ajaxUrl = "/p/svcs/getSampleProductData/";
                var url = ajaxUrl+pip.products.primary.data.info.sampleId+"?localStoreId="+pip.customer.localStore.storenumber;
                return $.ajax({
                    type:"GET",
                    url: url,
                    dataType: 'json',
                    async: true
                })
            }
        }
     };

     function shouldDisplayOrderSample() {
       return !!(utils.deepGet(pip, 'products.primary.data.info.sampleId')
           && utils.deepGet(pip, 'customer.localStore.storenumber'))
     }

    return{
        init: function init(){
            if(shouldDisplayOrderSample()) {
              model.fetch.samplePriceData().done(function (data) {
                view.updateDOM.updateSamplePrice(data);
                view.initEventListeners();
              }).fail(function (e) {
                if (pip.debugMode) {
                  console.error('Failed to load samplePriceData from orderSample.data', e);
                }
              })
            }
        },
        view: view,
        model: model
    }
});

}.call(window));